import { createListenerMiddleware, isAction } from '@reduxjs/toolkit';
import { resetFeedOrder } from '../state/feedOrderSlice';
import { BaseApi } from '../api/BaseAPI';

/**
 * This middleware listens for the updatePost mutation to be fulfilled and then resets the feed order
 * if the post has changed from draft to full post.
 *
 * This code doesn't use proper typings, as we couldn't figure that out, and could be brittly dependent on
 * RTK Query internals.
 */
export const postUpdateMiddleware = createListenerMiddleware<typeof BaseApi>();
postUpdateMiddleware.startListening({
	matcher: isAction,
	effect: async (action: any, listenerApi) => {
		if (
			action &&
			action.type &&
			action.type === 'BaseApi/executeMutation/fulfilled' &&
			action.meta.arg.endpointName === 'updatePost'
		) {
			const newPost = action.meta.arg.originalArgs.post;
			const state = listenerApi.getState() as unknown as any;
			const oldPost = state.BaseApi.queries[`getPost("${newPost._id}")`].data;
			if (oldPost.draft === true && newPost.draft === false) {
				listenerApi.dispatch(resetFeedOrder());
				listenerApi.dispatch(BaseApi.util.invalidateTags(['Post']));
			}
		}
	}
});
